{
  "next_step": "Next step",
  "confirm": "Confirm",
  "cancel": "Cancel",
  "skip": "Skip",
  "action": "Operations",
  "amount": "Amount",
  "details": "Details",
  "modify_success": "Modified Successfully",
  "submit": "Submit",
  "resend": "Resend",
  "reinput": "Re-enter",
  "currency": "Currency",
  "acknowledged": "Got it",
  "i18n_example": "I18n Example",
  "total_count": "Total {{total}} items",
  "error": "Error",
  "forbidden": "Access Denied",
  "not_found": "The resource was not found",
  "payload_too_large": "Upload file is too large",
  "server_error": "Server is busy, please try again later",
  "system_busy": "System is busy, please try again later",
  "success": "Success",
  "search_placeholder": "Search",
  "collapse": "Collapse",
  "expand": "Expand"
}
